import React from 'react';

export const CardDetailsMap = ({event}) => {
  return (
    <div data-w-id="4db98acf-151e-b8b5-28c8-d03c9b1db0f5" style={{ opacity: 1 }} className="site_map-content">
      <div className="margin-bottom margin-small">
        <h2 className="heading-7">Where you’ll be</h2>
      </div>
      <div className="map-block">
        <div className="map-embed w-embed w-iframe">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe 
                title="Location Map" 
                className="gmap_iframe" 
                width="100%" 
                frameBorder="0" 
                scrolling="no" 
                marginHeight="0" 
                marginWidth="0" 
                src={`https://maps.google.com/maps?q=${event?.location?.latitude || 0},${event?.location?.longitude || 0}&hl=en&z=14&output=embed`}
              ></iframe>
              <a href="https://kokagames.com/">Koka Games</a>
            </div>
            <style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:440px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:440px;}.gmap_iframe {height:440px!important;}" }} />
          </div>
        </div>
      </div>
      <div className="map_content-wrap">
        <div className="margin-top margin-medium">
          <h6 className="heading-6">{event?.location?.address}</h6>
        </div>
        <div className="text-weight-bold">{event?.organizerId?.phone}<br /></div>
        <div className="text-weight-bold">{event?.organizerId?.email}<br /></div>
      </div>
    </div>
  );
};
